import numericOnly from './numeric-only/'

export default {
  install(Vue) {
    Vue.directive('numeric-only', numericOnly)
  }
}
